<template>
  <button
    v-ripple
    class="ds-button"
    :class="{
      secondary,
      destructive,
      filled,
      dark,
      disabled,
      raised,
    }"
    :disabled="disabled"
    v-on="$listeners"
  >
    <v-icon
      v-if="prependIcon"
      class="ds-button-icon"
      size="24"
      v-text="prependIcon"
    />
    <span class="ds-button-content"><slot /></span>
    <v-icon
      v-if="icon"
      class="ds-button-icon"
      size="24"
      v-text="icon"
    />
  </button>
</template>

<script>
export default {
  name: 'DsButton',
  props: {
    icon: {
      type: String,
      default: undefined,
    },
    prependIcon: {
      type: String,
      default: undefined,
    },
    primary: {
      type: Boolean,
    },
    secondary: {
      type: Boolean,
    },
    destructive: {
      type: Boolean,
    },
    filled: {
      type: Boolean,
    },
    raised: {
      type: Boolean,
    },
    dark: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus">
@import "../../assets/stylus/variables.styl"

.ds-button {
  border-radius: 4px;
  padding: 8px;
  display: flex;
  gap: 8px;
  align-items: center;
  color: $nx-neutral-800;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  .disabled& {
    opacity: 0.6;
  }

  &-content {
    display: block;
    font-family: "Roboto";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    text-transform: uppercase;
  }

  .v-icon {
    color: inherit;
  }

  .dark& {
    color: white;
  }

  .filled& {
    color: white;
    background-color: $nx-primary-500;
  }

  .filled.dark& {
    color: $nx-primary-500;
    background-color: white;
  }

  .filled:hover& {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0.24) 100%), $nx-primary-500;
  }

  .raised& {
    color: white;
    background-color: $nx-primary-500;
    box-shadow: $nx-elevation-300;
  }

  .raised.dark& {
    color: $nx-primary-500;
    background-color: white;
    box-shadow: $nx-elevation-300;
  }

  .raised:hover& {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0.24) 100%), $nx-primary-500;
  }

  .secondary& {
    color: $nx-neutral-800;
    background-color: $nx-neutral-200;
  }

  .destructive& {
    color: $nx-error-500;
  }

  .destructive.dark& {
    color: $nx-error-100;
  }

  .destructive:hover& {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0.24) 100%), $nx-error-500;
  }
}
</style>
